var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('prd-loader'):_c('div',[_vm._v(" "+_vm._s(_vm.legalEntity)+" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.editInvoiceData}},[_vm._v("edit invoice data")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }